// Copyright (c) 2017 Deere & Company

import React, {Component, PropTypes} from 'react';
import {buildReportCurrency} from '../../../shared/services/build-number';

/* eslint-disable react/prefer-stateless-function */

class AmountCellRenderer extends Component {

    render() {

        return (
            <div className='amount-cell-renderer'>
                {buildReportCurrency(this.props.value)}
            </div>
        );

    }
}

AmountCellRenderer.displayName = 'CountCellRenderer';
AmountCellRenderer.propTypes = {
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]).isRequired
};
export default AmountCellRenderer;



// WEBPACK FOOTER //
// ./src/reports/shared/report-cell-renderers/amount-cell-renderer.js